module.exports = __webpack_public_path__ + "static/media/c_pink.b4d69b86.png";